export default __webpack_public_path__ + "static/media/Mani-Poses.1d312f07.png";